module.exports = __webpack_public_path__ + "img/retail-image-item-1.b51b39e0.png";